import { Routes } from '@angular/router'
import { AuthenticationGuard } from './auth-management/authentication.guard'
import { speechyAdminGuard } from './auth-management/speechy-admin.guard'
import { uuidMatcher } from './common/router/uuid-route-matcher'

export const routes: Routes = [
  {
    matcher: uuidMatcher,
    data: {
      id: 'main-route',
    },
    canActivate: [AuthenticationGuard],
    children: [
      {
        path: 'organizations',
        loadChildren: () => import('./organization-management/organization-management.routes').then(m => m.ORGANIZATION_ROUTES),
      },
      {
        path: 'users',
        loadChildren: () => import('./user-management/user-management.routes').then(r => r.USER_MANAGEMENT_ROUTES),
      },
      {
        path: 'reports',
        loadChildren: () => import('./reports/reports.routes').then(r => r.REPORTS_ROUTES),
      },
    ],
  },
  {
    path: 'admin',
    canActivate: [AuthenticationGuard, speechyAdminGuard],
    children: [
      {
        path: 'users/all',
        loadComponent: () =>
          import('./user-management/pages/all-users-page/all-users-page.component').then(m => m.AllUsersPageComponent),
      },
    ],
  },
  {
    path: 'login',
    loadComponent: () => import('./auth-management/components/login/login-page.component').then(m => m.LoginPageComponent),
  },
  {
    path: 'auth/callback',
    loadComponent: () => import('./auth-management/components/callback/callback.component').then(m => m.CallbackComponent),
  },
  {
    path: '404',
    loadComponent: () => import('./common/router/not-found-page/not-found-page.component').then(m => m.NotFoundPageComponent),
  },
  {
    path: '403',
    loadComponent: () => import('./common/router/unauthorized-page/unauthorized-page.component').then(m => m.UnauthorizedPageComponent),
  },
  {
    path: '500',
    loadComponent: () => import('./common/router/internal-error-page/internal-error-page.component').then(m => m.InternalErrorPageComponent),
  },

  {
    path: '**',
    canActivate: [AuthenticationGuard],
    loadComponent: () => import('./common/router/redirection.component').then(m => m.RedirectionComponent),
  },
]
